import Reveal from "../components/ui/Reveal";
import { TEAM } from "../constants/data";
import { fonts } from "../constants/theme";

const biographies = {
  "Melanie Salazar": "Cofundadora de VittaLink, proyecto que combina máquinas expendedoras inteligentes y nutrición para acercar snacks saludables a espacios de estudio, trabajo y actividad física.",
  "Hansell Rodriguez": "Cofundador de VittaLink, iniciativa que conecta tecnología y bienestar para hacer más accesibles las opciones nutritivas en la vida diaria.",
};

export default function TeamPage() {
  return (
    <section className="team-page-page" style={{ minHeight: "100vh", padding: "7rem 20px 5rem", position: "relative", overflow: "hidden", background: "#ffffff" }}>
      <style>{`
        .team-page-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 22px; }
        .team-page-card { display: grid; grid-template-columns: 210px minmax(0, 1fr); min-height: 310px; overflow: hidden; border: 1px solid #e4ece5; border-radius: 26px; background: #ffffff; box-shadow: 0 14px 36px rgba(15, 46, 27, .08); }
        .team-page-card img { width: 100%; height: 100%; min-height: 310px; object-fit: cover; object-position: center top; }
        @media (max-width: 900px) { .team-page-grid { grid-template-columns: 1fr; max-width: 680px; margin: 0 auto; } }
        @media (max-width: 560px) {
          .team-page-page { padding: 5.8rem 14px 3.5rem !important; }
          .team-page-header { margin-bottom: 1.6rem !important; }
          .team-page-title { font-size: clamp(2rem, 8.4vw, 2.7rem) !important; margin: .85rem 0 .7rem !important; }
          .team-page-intro { font-size: .9rem !important; line-height: 1.6 !important; }
          .team-page-card { grid-template-columns: 1fr; }
          .team-page-card img { height: 215px; min-height: 215px; object-position: center 25%; }
          .team-page-bio { padding: 1.2rem 1.25rem 1.35rem !important; }
          .team-page-name { font-size: 1.35rem !important; margin: .5rem 0 .65rem !important; }
        }
      `}</style>

      <div style={{ position: "absolute", width: 420, height: 420, left: "-12%", top: "18%", borderRadius: "50%", background: "rgba(34, 197, 94, .055)", filter: "blur(90px)", pointerEvents: "none" }} />
      <div className="team-page-section" style={{ width: "min(1120px, 100%)", margin: "0 auto", position: "relative" }}>
        <Reveal>
          <header className="team-page-header" style={{ maxWidth: 740, margin: "0 auto 2.2rem", textAlign: "center" }}>
            <span style={{ display: "inline-flex", padding: "8px 13px", borderRadius: 99, border: "1px solid #d5ead7", background: "#f0f8f0", color: "#24763d", font: `800 .72rem ${fonts.body}`, letterSpacing: ".13em", textTransform: "uppercase" }}>
              Equipo fundador
            </span>
            <h1 className="team-page-title" style={{ color: "#10251a", font: `900 clamp(2.3rem, 5vw, 4rem)/1.05 ${fonts.display}`, letterSpacing: "-.04em", margin: "1rem 0 .85rem" }}>
              Las personas detrás de <span style={{ color: "#218344" }}>VittaLink</span>
            </h1>
            <p className="team-page-intro" style={{ maxWidth: 610, margin: "0 auto", color: "#637469", font: `400 1rem/1.75 ${fonts.body}` }}>
              Conoce a Melanie Salazar y Hansell Rodriguez, los cofundadores de una iniciativa que conecta nutrición, tecnología y bienestar en la vida diaria.
            </p>
          </header>
        </Reveal>

        <div className="team-page-grid">
          {TEAM.map((member, index) => (
            <Reveal key={member.name} delay={index * .08}>
              <article className="team-page-card">
                <img src={member.photo} alt={`Retrato de ${member.name}`} />
                <div className="team-page-bio" style={{ padding: "1.7rem 1.5rem", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <span style={{ color: "#218344", font: `800 .7rem ${fonts.body}`, letterSpacing: ".12em", textTransform: "uppercase" }}>{member.role}</span>
                  <h2 className="team-page-name" style={{ color: "#10251a", font: `800 1.55rem/1.2 ${fonts.display}`, letterSpacing: "-.025em", margin: ".7rem 0 1rem" }}>{member.name}</h2>
                  <p style={{ color: "#5b6e61", font: `400 .9rem/1.75 ${fonts.body}`, margin: 0 }}>{biographies[member.name]}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={.12}>
          <div style={{ margin: "2rem auto 0", maxWidth: 820, padding: "1.3rem 1.5rem", borderTop: "1px solid #e5ece6", textAlign: "center", color: "#68796d", font: `500 .86rem/1.7 ${fonts.body}` }}>
            VittaLink nació para acercar alternativas saludables a universidades, oficinas y centros deportivos, con una experiencia sencilla y conectada.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
